<template>
    <div ref="carousel" class="electric-vehicle-soft-search__last-step-vehicle-carousel">
        <div v-for="vehicle in vehicles" :key="vehicle.id" class="electric-vehicle-soft-search__slick-padding">
            <soft-search-vehicle
                v-if="vehicle !== null"
                :vehicle="vehicle"
                :electricOrHybrid="electricOrHybrid"
            ></soft-search-vehicle>
        </div>
    </div>
</template>

<script>
    import SoftSearchVehicle from "./SoftSearchVehicle";
    import { MatchHeight } from "js-match-height";

    export default {
        props: {
            vehicles: {
                required: true,
            },
            electricOrHybrid: {
                required: true,
            },
        },
        data() {
            return {};
        },
        components: {
            SoftSearchVehicle
        },
        methods: {
            initSlick() {
                try {
                    $(this.$refs['carousel']).slick('unslick');
                } catch (error) {
                    console.error('Nothing to unslick');
                }
                $(this.$refs['carousel']).on('init', function() {
                    new MatchHeight(".electric-vehicle-soft-search__vehicle-title");
                });
                $(this.$refs['carousel']).slick({
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: false,
                    nextArrow: false,
                    mobileFirst: true,
                });
            },
        },
        watch: {
            vehicles: function(newValue, oldValue) {
                this.initSlick();
            }
        },
        mounted() {
            this.initSlick();
        },
        beforeDestroy() {
            try {
                $(this.$refs['carousel']).slick('unslick');
            } catch (error) {
                console.error('Nothing to unslick');
            }
        }
    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/soft-search/SoftSearchCarousel.vue